export enum MessageTypeEnum {
  text = "text",
  loading = "loading",
  error = "error",
  video = "video",
}

export enum LoadingMessageEnum {
  stt = "語音轉文字中",
  gpt = "搜尋中",
  video = " ",
}

export enum RoleEnum {
  human = "human",
  ai = "ai",
}
